var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21238_2099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00749 16C7.19058 16 6.38116 15.7619 5.74411 15.2933L2.52141 12.5182C1.66702 11.8858 1 10.5616 1 9.51271V4.36499C1 3.21934 1.84689 1.9993 2.93362 1.59758L6.67345 0.20644C7.41542 -0.0688132 8.58458 -0.0688132 9.32655 0.20644L13.0664 1.59758C14.1531 1.9993 15 3.21934 15 4.36499V9.50527C15 10.5616 14.333 11.8784 13.4786 12.5107L10.2559 15.2858C9.63383 15.7619 8.82441 16 8.00749 16Z",
    fill: "#E45C51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 4.19983V8.64433",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99121 11.3112H7.99951",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21238_2099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDanger);
export default __webpack_public_path__ + "static/media/shield-danger.741e1391cac7c7692bcef689134deac8.svg";
export { ForwardRef as ReactComponent };